export default __webpack_public_path__ + "static/team-img-600b05552ecdfcbae5a57d6bfea560be.jpg";